import React from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import ListIcon from '@mui/icons-material/ViewList'
import CardIcon from '@mui/icons-material/ViewModule'
import { listingType } from '../utils'

const OfferDisplayToggle = ({ displayMode, onChange }) => (
  <Box sx={{ display: { xs: 'none', lg: 'flex' } }}>
    <Tooltip title="List view">
      <IconButton
        aria-label="list view"
        aria-pressed={displayMode === listingType.list}
        color={displayMode === listingType.list ? 'primary' : 'default'}
        onClick={() => onChange(listingType.list)}
      >
        <ListIcon />
      </IconButton>
    </Tooltip>
    <Tooltip title="Card view">
      <IconButton
        aria-label="cards view"
        aria-pressed={displayMode === listingType.card}
        color={displayMode === listingType.card ? 'primary' : 'default'}
        onClick={() => onChange(listingType.card)}
      >
        <CardIcon />
      </IconButton>
    </Tooltip>
  </Box>
)

export default OfferDisplayToggle
